import { createMediaButton } from "../create-media-button.js";
import { PlaybackRateButtonCore, PlaybackRateButtonDataAttrs } from "@videojs/core";
import { selectPlaybackRate } from "@videojs/core/dom";
//#region src/ui/playback-rate-button/component.tsx
/**
* A button that cycles through playback rates.
*
* @example
*   ```tsx
*   <PlaybackRateButton />
*
*   <PlaybackRateButton
*   render={(props, state) => (
*   <button {...props}>
*   {state.rate}&times;
*   </button>
*   )}
*   />
*   ```;
*/
const PlaybackRateButton = createMediaButton({
	displayName: "PlaybackRateButton",
	core: PlaybackRateButtonCore,
	stateAttrMap: PlaybackRateButtonDataAttrs,
	selector: selectPlaybackRate,
	action: (core, state) => core.cycle(state),
	hotkeyAction: "speedUp"
});
//#endregion
export { PlaybackRateButton };

//# sourceMappingURL=component.js.map